module.exports = __webpack_public_path__ + "img/pedido-banner.8562ff8a.png";